import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=c2bde3e0&"
import script from "./Module.vue?vue&type=script&lang=js&"
export * from "./Module.vue?vue&type=script&lang=js&"
import style0 from "./Module.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2bde3e0')) {
      api.createRecord('c2bde3e0', component.options)
    } else {
      api.reload('c2bde3e0', component.options)
    }
    module.hot.accept("./Module.vue?vue&type=template&id=c2bde3e0&", function () {
      api.rerender('c2bde3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/Module.vue"
export default component.exports